import React, { useState } from 'react'
import CoursesProgress from './components/courses-progress'
import { Folders } from './components/Folders'
import Premieres from './components/Premieres'
import { LearningPaths } from './components/LearningPaths'

export default function Home() {
  const [search, setSearch] = useState('')

  return (
    <React.Fragment>
      <CoursesProgress search={search} onChangeSearch={setSearch} />
      <LearningPaths search={search} />
      <Premieres search={search} />
      <Folders search={search} />
    </React.Fragment>
  )
}
